export default __webpack_public_path__ + "static/media/KZ.M.13.2071.a1171dfb.svg";